export const brushToolVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const brushToolFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform vec2 u_size;
uniform float u_opacity;
uniform vec3 u_color;
uniform vec2 u_coords;
uniform float u_brushSize;

out vec4 outColor;

void main() {
  vec2 pixel = u_size * v_texCoord; // 0.0 -> u_size
    
  float dist = distance(pixel, u_coords);
  float halfBrushSize = u_brushSize / 2.0;
  
  if (dist < halfBrushSize) {
    outColor = vec4(u_color, u_opacity);
    return;
  }
  
  discard;
}`;
